import backLineAnalysis from './backLineAnalysis.vue';
export default backLineAnalysis;
